const dataRoadmap = [


    
    /*
    {
        id: 1,
        time: 'Q2 2022',
        list: [
            {
                text: 'Aenean tempor'
            },
            {
                text: 'Fusce arcu maecenas'
            },
            {
                text: 'Malesuada felis sem elementum'
            },
            {
                text: 'Risus eu metus'
            },
        ],
        positon: 'left',
        style: 'normal'
    },

    
    {
        id: 2,
        time: 'Q3 2022',
        list: [
            {
                text: 'Release website and logo'
            },
            {
                text: 'Grow community'
            },
            {
                text: 'Launch the project'
            },
            {
                text: 'Social media setup'
            },
        ],
        positon: 'right',
        style: 'normal'
    },

    */
    {
        id: 1,
        time: 'Q2/Q3 2024',
        list: [
            {
                text: 'Collection design and creative direction kicked off in March 2024.'
                
            },

            {
                text: 'Animal references and pirate motifs shaped the core visual language.'
            },

            {
                text: '232 on-chain traits were mapped across 31 categories.'
            },
            
        
        ],
        positon: 'left'
    },
    {
        id: 4,
        time: 'Q3 2024',
        list: [
            {
                text: 'Community feedback informed the final collection generation.'
            },

            {
                text: 'Marketplace preparation and launch partner conversations progressed.'
            },
            {
                text: 'The first public website went live.'
                
            },
        
        
        ],
        positon: 'right'
    },
    {
        id: 5,
        time: 'Q2/3 2025',
        list: [
            {
                text: 'Marketplace launch preparation and campaign planning moved into production.'
            },
            {
                text: 'Multi-platform marketing and community growth began.'
            },
            {
                text: 'Public launch targeted for late 2025.'
            },
            
        ],
        positon: 'left'
    },
    
    {
        id: 6,
        time: 'Q4 2025',
        list: [
            {
                text: 'Second collection concept: a free holder airdrop for Block Pirates Chimp owners.'
            },
            {
                text: 'Exploration of future token-gated or collector-only experiences.'
            },
            {
                text: 'Collection size: 10,000.'
            },

            {
                text: 'Type: Ordinals / Bitcoin NFTs'
            },
           
        ],
        positon: 'right'
    },

    /*


    {
        id: 7,
        time: 'Q2 2023',
        list: [
            {
                text: 'Launching the next genration..'
            },
            {
                text: 'New residents..'
            },
            {
                text: 'Tokennomics.'
            },
            {
                text: 'Marketplace engagement.'
            },
        ],
        positon: 'left'
    },

    
    {
        id: 8,
        time: 'Q3 2023',
        list: [
          
            {
                text: 'Commuinty perks in recognition.'
            },
            {
                text: 'Test trial of the Blockchian Pirate Bay'
            },
            {
                text: 'Community and user feedback review.'
            },
          
        ],
        positon: 'right'
    },
    {
        id: 9,
        time: 'Q4 2023',
        list: [
            {
                text: 'Official launch of The Bay.'
            },

            {
                text: 'The sucess of our journey is heavily reliant on the project success and fund raising from the sales etc.'
            },

            {
                text: 'Despite the current market sentimentW, we are so excited for the future of the project! Builder just keep building regadrsless of the weather!'
            },
           
           
        ],
        positon: 'left'
    },

    

    /*
    {
        id: 10,
        time: 'Q1 2024',
        list: [
            {
                text: 'Aenean tempor'
            },
            {
                text: 'Fusce arcu maecenas'
            },
            {
                text: 'Malesuada felis sem elementum'
            },
            {
                text: 'Risus eu metus'
            },
        ],
        positon: 'right'
    },

    */

    
]

export default dataRoadmap;
